import ExternalLinks from '@components/ExternalLinks';

import style from './styles.module.scss';

const Footer = () => {
  return (
    <footer className={style.footer}>
      <ExternalLinks />
    </footer>
  );
};

export default Footer;
